import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
const taskVuex = createNamespacedHelpers("task");
const gameVuex = createNamespacedHelpers("game");
const walletVuex = createNamespacedHelpers("wallet");
import vailcode from "@utils/errcode";
import { Mining } from "@assets/js/Mining.js";
import { address, toNano } from "@ton/core";
export default {
  name: "bot",
  computed: {
    ...userVuex.mapState(["isLogin", "userInfo", "balanceInfo"]),
    ...taskVuex.mapState(["taskInfo", "timerObjs"]),
    ...gameVuex.mapState(["gameProgress"]),
    ...walletVuex.mapState(["tonConnect"])
  },
  data() {
    return {
      // progress: 80,
      popBotUpgradeShow: false,
      popBotUnlockInfoShow: false,
      popStoreUpgradeShow: false,
      popSelectPaymentShow: false,
      summaryInfo: {
        active_count: 1,
        eph: 0
      },
      minerList: [],
      poolInfo: {
        cpb: 0,
        gpb: 0
      },
      storageInfo: {
        capacity: 0,
        stock: {
          coins: 0,
          percent: 0
        }
      },
      miningObj: null,
      mintBotSimpleCount: 0,
      isClaimLoading: false,
      rowMiner: null,
      isStartFreeLoading: false,
      payType: "Stars",
      //Stars或TON
      rowStore: null,
      storePriceList: [],
      storePriceListLoading: false,
      rowStorePrice: null,
      storeProgress: 0,
      isUpgradeStore: false
    };
  },
  watch: {
    isLogin: {
      async handler(bool) {
        if (bool) {
          const data = await this.getMintBotInfo();
          if (!data) {
            return;
          }
          this.miningObj = new Mining(data, {
            claimCallback: this.claimMining
          });
          this.calcMining(null, false);
          this.animateProgress();
          this.poolMinning();
          await this.getStoreUpagradePrices();
        }
      },
      deep: true,
      immediate: true
    },
    popBotUnlockInfoShow(bool) {
      if (!bool) {
        this.isStartFreeLoading = false;
      }
    },
    popBotUpgradeShow(bool) {
      if (!bool) {
        this.payType = "Stars";
      }
    },
    popSelectPaymentShow(bool) {
      if (!bool) {
        this.payType = "Stars";
      }
    }
  },
  methods: {
    ...userVuex.mapMutations(["setUserInfo"]),
    ...userVuex.mapActions(["getBalanceInfo"]),
    ...taskVuex.mapActions(["openInvoiceStarPay"]),
    animateProgress() {
      clearInterval(this.timerObjs.botPage.animateProgressTimer);
      const hasActive = this.minerList.some(item => item.active === true);
      if (!hasActive) return;
      const targetCount = 10; // 每格代表10%
      this.timerObjs.botPage.animateProgressTimer = setInterval(() => {
        this.storeProgress++;
        if (this.storeProgress > targetCount) {
          this.storeProgress = 0;
        }
      }, 200); // 每格激活间隔
    },

    onSelectPay(type) {
      this.payType = type;
    },
    async onBoostShow() {
      this.popStoreUpgradeShow = true;
      if (this.storePriceList.length <= 0) {
        await this.getStoreUpagradePrices();
      }
    },
    upgradeBotShow(item, index) {
      if (!item.next) {
        return;
      }
      this.setRowMiner(item, index);
      this.popBotUpgradeShow = true;
    },
    onStartFreeShow(item, index) {
      this.setRowMiner(item, index);
      this.popBotUnlockInfoShow = true;
    },
    setRowMiner(item, index) {
      this.rowMiner = {
        ...item,
        codeIndex: index + 1 <= 6 ? index + 1 : 6,
        index
      };
    },
    async onStartFree() {
      if (this.isStartFreeLoading) return;
      this.isStartFreeLoading = true;
      const res = await this.unlockMiner(this.rowMiner.index);
      if (!res) {
        this.isStartFreeLoading = false;
        return;
      }
      await this.changeBotItemInfo({
        ...res,
        index: this.rowMiner.index
      }, {
        isLock: true
      });
      this.isStartFreeLoading = false;
      this.popBotUnlockInfoShow = false;
      this.animateProgress();
    },
    async getMintBotInfo(params) {
      const _params = {
        simple: 0,
        ...params
      };
      return new Promise(async resolve => {
        const res = await this.$http.post("/mining/info", _params);
        vailcode(res, () => {
          const data = res.data;
          this.summaryInfo = data?.miner?.summary;
          this.poolInfo = data?.pool;
          if (data?.miner.list) {
            this.minerList = data?.miner?.list.map(item => {
              return {
                ...item,
                isLock: false,
                isUpgrade: false,
                timer: null,
                isPayLoading: false,
                hrValue: this.fmt_pre(item.current.properties.pph),
                nextHrValue: item.next ? this.fmt_pre(item.next.properties.pph) : null
              };
            });
          }
          this.storageInfo = data?.storage;
          resolve(data);
        }, () => resolve());
      });
    },
    async claimMining(stock) {
      try {
        const result = await this.$http.post("/mining/claim", {
          stock: JSON.stringify(stock)
        });
        return result;
      } catch (err) {
        return {
          code: 500,
          message: err.message,
          data: null
        };
      }
    },
    poolMinning() {
      clearTimeout(this.timerObjs.botPage.miningTimer);
      this.timerObjs.botPage.miningTimer = setTimeout(async () => {
        this.mintBotSimpleCount++;
        const mintBotSimpleMax = 20;
        if (this.mintBotSimpleCount >= mintBotSimpleMax) {
          const res = await this.getMintBotInfo({
            simple: 1
          });
          if (res) {
            this.calcMining(res, false);
          }
          this.mintBotSimpleCount = 0;
        } else {
          this.calcMining(null, false);
        }
        this.poolMinning();
      }, 1000);
    },
    async onClaim() {
      if (this.storageInfo?.stock?.coins <= 0) return;
      if (this.isClaimLoading) return;
      this.isClaimLoading = true;
      const res = await this.miningObj.claim();
      if (res.code == 501 || res.code == 500) {
        this.isClaimLoading = false;
        return;
      }
      this.isClaimLoading = false;
      const data = res.data;
      this.taskInfo.popReward.reward = data.balance.coins - this.userInfo.coin;
      this.setUserInfo({
        ...this.userInfo,
        coin: data.balance.coins
      });
      this.taskInfo.popReward.icon = "COIN";
      this.taskInfo.popReward.show = true;
      this.calcMining(res.data.mining);
    },
    calcMining(res, isAnimStoreProgress = true) {
      const calcRes = this.miningObj.reset(res);
      const stock = calcRes.stock;
      this.storageInfo.stock = stock;
      const storeProgress = this.storageInfo.stock.coins / this.storageInfo.capacity * 10;
      if (isAnimStoreProgress) {
        this.storeProgress = storeProgress;
      }
    },
    unlockMiner(index) {
      return new Promise(async resolve => {
        const res = await this.$http.post("/mining/miner/unlock", {
          index
        });
        // const res = {
        //   code: 0,
        //   message: "",
        //   data: {
        //     id: 20,
        //     name: "MintBot-03",
        //     active: true,
        //     level: 0,
        //     energy: -1,
        //     last_store_time: 0,
        //     unlock_cost: {
        //       user_level: 2,
        //     },
        //     current: {
        //       properties: {
        //         pph: 720,
        //       },
        //       cost: {
        //         stars: 0,
        //         ton: 0,
        //       },
        //     },
        //     next: {
        //       properties: {
        //         pph: 1080,
        //       },
        //       cost: {
        //         stars: 85,
        //         ton: 0.34,
        //       },
        //     },
        //     mining: {
        //       pool: {
        //         cpb: 1,
        //         gpb: 0,
        //       },
        //       miner: {
        //         summary: {
        //           active_count: 3,
        //           pph: 46002,
        //           current_time: 1750358244370,
        //           last_calc_time: 1750358244362,
        //         },
        //       },
        //       storage: {
        //         capacity: 58120,
        //         stock: {
        //           coins: 58120,
        //           percent: 100,
        //         },
        //       },
        //     },
        //   },
        // };
        console.log("rewssssss", res);
        vailcode(res, () => {
          const data = res.data;
          resolve(data);
        }, () => resolve());
      });
    },
    upgradeBot(params) {
      return new Promise(async resolve => {
        const res = await this.$http.post("/mining/miner/upgrade", params);
        if (res && res.code > 0) {
          resolve(res);
          return;
        }
        resolve(res);
      });
    },
    async onUpgradePay() {
      const fnc = async () => {
        let params = {
          index: this.rowMiner.index,
          toLevel: this.rowMiner.level + 1,
          currency: this.payType
        };
        if (this.payType === "Ton") {
          params["address"] = this.tonWallet.uiAddress;
        }
        if (this.rowMiner.isPayLoading) return;
        this.minerList[this.rowMiner.index].isPayLoading = this.rowMiner.isPayLoading = true;
        const res = await this.upgradeBot(params);
        if (!res) {
          this.minerList[this.rowMiner.index].isPayLoading = this.rowMiner.isPayLoading = false;
          return;
        }
        let data = res.data;
        console.log("datadatadatadatadata", data);
        if (this.payType === "Ton" && data?.chainInfo) {
          let msg = [{
            address: data.chainInfo.contract,
            amount: toNano(data.chainInfo.amount).toString(),
            payload: data.chainInfo.raw
          }];
          const payRef = await this.tonWallet.sendTransaction(msg);
          if (!payRef) {
            this.minerList[this.rowMiner.index].isPayLoading = this.rowMiner.isPayLoading = false;
            return;
          }
          const upRes = await this.poolPayUpgradeBot(data);
          console.log("upResupResupRes123", upRes);
          if (!upRes) return;
          this.popBotUpgradeShow = false;
          await this.changeBotItemInfo({
            ...upRes.data,
            index: this.rowMiner.index
          });
        } else if (this.payType == "Stars" && data?.chainInfo) {
          const payRef = await this.openInvoiceStarPay({
            url: data.chainInfo.payment_url
          });
          if (!payRef) {
            this.minerList[this.rowMiner.index].isPayLoading = this.rowMiner.isPayLoading = false;
            return;
          }
          const upRes = await this.poolPayUpgradeBot(data);
          console.log("upResupResupResupRes456", upRes);
          if (!upRes) return;
          this.popBotUpgradeShow = false;
          await this.changeBotItemInfo({
            ...upRes.data,
            index: this.rowMiner.index
          });
          await this.getBalanceInfo(false);
        } else {
          console.log("hhhhhhhhhh");
          this.minerList[this.rowMiner.index].isPayLoading = this.rowMiner.isPayLoading = false;
          this.popBotUpgradeShow = false;
          await this.changeBotItemInfo({
            ...data,
            index: this.rowMiner.index
          });
          this.calcMining(res.data.mining);
          await this.getBalanceInfo(false);
          return;
        }
        console.log("datadatadatadata", data);
      };
      clearInterval(this.timerObjs.botPage.upgradeBotTonConnectTimer);
      if (this.payType === "Ton" && !this.tonConnect) {
        this.tonWallet.connectTon();
        this.timerObjs.botPage.upgradeBotTonConnectTimer = setInterval(async () => {
          if (this.tonConnect) {
            clearInterval(this.timerObjs.botPage.upgradeBotTonConnectTimer);
            fnc();
          }
        }, 1000);
      } else {
        fnc();
      }
    },
    async poolPayUpgradeBot(resp) {
      return new Promise(async resolve => {
        const rowMiner = this.rowMiner;
        const fnc = async resp => {
          this.timerObjs.botPage.upgradeBotPayTimer = setTimeout(async () => {
            let params = {
              index: rowMiner.index,
              toLevel: rowMiner.level + 1,
              currency: this.payType,
              address: this.tonWallet.uiAddress,
              paymentId: resp.paymentId
            };
            const res = await this.upgradeBot(params);
            if (!res) {
              this.$toasted.error("Upgrade failed, please try again");
              clearTimeout(this.timerObjs.botPage.upgradeBotPayTimer);
              this.minerList[rowMiner.index].isPayLoading = this.rowMiner.isPayLoading = false;
              resolve();
            } else if (res.code == 302) {
              clearTimeout(this.timerObjs.botPage.upgradeBotPayTimer);
              await fnc(resp);
            } else if (res.code > 0) {
              this.minerList[rowMiner.index].isPayLoading = this.rowMiner.isPayLoading = false;
              clearTimeout(this.timerObjs.botPage.upgradeBotPayTimer);
              this.$toasted.error(res.message);
              resolve();
            } else {
              setTimeout(() => {
                clearTimeout(this.timerObjs.botPage.upgradeBotPayTimer);
                this.minerList[rowMiner.index].isPayLoading = this.rowMiner.isPayLoading = false;
                resolve(res);
              }, 5000);
            }
          }, 1000);
        };
        await fnc(resp);
      });
    },
    async changeBotItemInfo(item, type = {
      isUpgrade: true
    }) {
      const res = await this.getMintBotInfo({
        simple: 1
      });
      if (res) {
        this.calcMining(res);
      }
      this.minerList.splice(item.index, 1, {
        ...item,
        ...type,
        timer: null,
        isPayLoading: false,
        hrValue: this.fmt_pre(item.current.properties.pph),
        nextHrValue: this.fmt_pre(item.next.properties.pph)
      });
      setTimeout(() => {
        if (type?.isUpgrade) {
          this.minerList[item.index].isUpgrade = false;
        } else if (type?.isLock) {
          this.minerList[item.index].isLock = false;
        }
      }, 2000);
    },
    async changeStoreInfo() {
      const res = await this.getMintBotInfo({
        simple: 1
      });
      if (res) {
        this.calcMining(res);
      }
      this.$toasted.success("Upgrade inventory successful!");
      this.isUpgradeStore = true;
      setTimeout(() => {
        this.isUpgradeStore = false;
      }, 2000);
    },
    getStoreUpagradePrices() {
      return new Promise(async resolve => {
        const res = await this.$http.post("/mining/storage/prices", {});
        vailcode(res, () => {
          const data = res.data.map(item => {
            return {
              ...item,
              isLoading: false
            };
          });
          if (!data) {
            resolve();
            return;
          }
          const firstItem = data[0];
          console.log("firstItem", firstItem);
          this.storePriceList = data.map((item, index) => {
            console.log("firstItemfirstItem", firstItem, item);
            return {
              ...item,
              off: index == 0 ? null : this.fmt_pre((1 - firstItem.count / firstItem.cost.stars / (item.count / item.cost.stars)) * 100, 2)
            };
          });
          console.log("this.storePriceList", this.storePriceList);
          resolve(data);
        }, () => resolve());
      });
    },
    selectStorePrice(item, index) {
      if (item.isLoading) return;
      this.rowStorePrice = {
        ...item,
        index,
        isLoading: false
      };
      this.popSelectPaymentShow = true;
    },
    onPayUpgradeStore() {
      const fnc = async () => {
        let params = {
          optionIndex: this.rowStorePrice.index,
          currency: this.payType
        };
        if (this.payType === "Ton") {
          params["address"] = this.tonWallet.uiAddress;
        }
        if (this.rowStorePrice.isLoading) return;
        this.storePriceList[this.rowStorePrice.index].isLoading = this.rowStorePrice.isLoading = true;
        const res = await this.upgradeStore(params);
        if (!res) {
          this.storePriceList[this.rowStorePrice.index].isLoading = this.rowStorePrice.isLoading = false;
          return;
        }
        let data = res.data;
        if (this.payType === "Ton" && data?.chainInfo) {
          let msg = [{
            address: data.chainInfo.contract,
            amount: toNano(data.chainInfo.amount).toString(),
            payload: data.chainInfo.raw
          }];
          const payRef = await this.tonWallet.sendTransaction(msg);
          if (!payRef) {
            this.storePriceList[this.rowStorePrice.index].isLoading = this.rowStorePrice.isLoading = false;
            return;
          }
          const upRes = await this.poolPayUpgradeStore(data);
          if (!upRes) return;
          this.popSelectPaymentShow = false;
          this.popStoreUpgradeShow = false;
          await this.changeStoreInfo();
        } else if (this.payType == "Stars" && data?.chainInfo) {
          const payRef = await this.openInvoiceStarPay({
            url: data.chainInfo.payment_url
          });
          if (!payRef) {
            this.storePriceList[this.rowStorePrice.index].isLoading = this.rowStorePrice.isLoading = false;
            return;
          }
          const upRes = await this.poolPayUpgradeStore(data);
          console.log("upResupResupResupRes", upRes);
          if (!upRes) {
            this.storePriceList[this.rowStorePrice.index].isLoading = this.rowStorePrice.isLoading = false;
            return;
          }
          this.popSelectPaymentShow = false;
          this.popStoreUpgradeShow = false;
          await this.changeStoreInfo();
          await this.getBalanceInfo(false);
        } else {
          this.storePriceList[this.rowStorePrice.index].isLoading = this.rowStorePrice.isLoading = false;
          this.popSelectPaymentShow = false;
          this.popStoreUpgradeShow = false;
          await this.changeStoreInfo();
          await this.getBalanceInfo(false);
        }
      };
      clearInterval(this.timerObjs.botPage.upgradeStoreTonConnectTimer);
      if (this.payType === "Ton" && !this.tonConnect) {
        this.tonWallet.connectTon();
        this.timerObjs.botPage.upgradeStoreTonConnectTimer = setInterval(async () => {
          if (this.tonConnect) {
            clearInterval(this.timerObjs.botPage.upgradeStoreTonConnectTimer);
            fnc();
          }
        }, 1000);
      } else {
        fnc();
      }
    },
    upgradeStore(params) {
      return new Promise(async resolve => {
        const res = await this.$http.post("/mining/storage/upgrade", params);
        if (res.code > 0) {
          resolve(res);
          return;
        }
        resolve(res);
      });
    },
    async poolPayUpgradeStore(resp) {
      return new Promise(async resolve => {
        const rowStorePrice = this.rowStorePrice;
        const fnc = async resp => {
          this.timerObjs.botPage.upgradeStorePayTimer = setTimeout(async () => {
            let params = {
              optionIndex: rowStorePrice.index,
              currency: this.payType,
              address: this.tonWallet.uiAddress,
              paymentId: resp.paymentId
            };
            const res = await this.upgradeStore(params);
            if (!res) {
              this.$toasted.error("Upgrade failed, please try again");
              this.storePriceList[this.rowStorePrice.index].isLoading = this.rowStorePrice.isLoading = false;
              resolve();
            } else if (res.code == 302) {
              clearTimeout(this.timerObjs.botPage.upgradeStorePayTimer);
              await fnc(resp);
            } else if (res.code > 0) {
              this.storePriceList[this.rowStorePrice.index].isLoading = this.rowStorePrice.isLoading = false;
              clearTimeout(this.timerObjs.botPage.upgradeStorePayTimer);
              this.$toasted.error(res.message);
              resolve();
            } else {
              setTimeout(() => {
                clearTimeout(this.timerObjs.botPage.upgradeStorePayTimer);
                this.storePriceList[this.rowStorePrice.index].isLoading = this.rowStorePrice.isLoading = false;
                resolve(res);
              }, 5000);
            }
          }, 1000);
        };
        await fnc(resp);
      });
    }
  },
  beforeDestroy() {
    clearTimeout(this.timerObjs.botPage.miningTimer);
    clearInterval(this.timerObjs.botPage.upgradeBotTonConnectTimer);
    clearInterval(this.timerObjs.botPage.upgradeStoreTonConnectTimer);
    clearTimeout(this.timerObjs.botPage.upgradeBotPayTimer);
    clearTimeout(this.timerObjs.botPage.upgradeStorePayTimer);
    clearInterval(this.timerObjs.botPage.animateProgressTimer);
    console.log(777);
  }
};